<template>
    <profile-posts :user-id="currentUserId" />
</template>

<script>
    import ProfilePosts from './ProfilePosts'

    export default {
        name: "OtherUserProfilePosts",
        components: { ProfilePosts },

        computed: {
            currentUserId: function () {
                return Number(this.$route.params.id)
            }
        }
    }
</script>
